var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, ThemeProvider } from 'styled-components';
import { BlueButton } from '@hn-ui/buttons';
import Stub from './images/stub.svg';
import themeDefault from '../../../landing/components/core/themes/theme';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-5o17ud" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  margin: 0 auto;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n"], ["\n  display: flex;\n  flex-flow: column;\n  margin: 0 auto;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var Title = styled.h2.withConfig({ displayName: "Title", componentId: "sc-z5fd3x" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: Noto Sans, sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n"], ["\n  font-family: Noto Sans, sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n"])));
var Text = styled.p.withConfig({ displayName: "Text", componentId: "sc-dsuaoy" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: Noto Sans, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  max-width: 512px;\n  text-align: center;\n  margin-bottom: 32px;\n"], ["\n  font-family: Noto Sans, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  max-width: 512px;\n  text-align: center;\n  margin-bottom: 32px;\n"])));
var ScStub = styled(Stub).withConfig({ displayName: "ScStub", componentId: "sc-1ex2j0s" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 100px;\n"], ["\n  margin-top: 100px;\n"])));
var EmptyClass = function (_a) {
    var redirectUrl = _a.redirectUrl, rest = __rest(_a, ["redirectUrl"]);
    var handleOnClick = function () {
        window.location.href = redirectUrl;
    };
    return (_jsx(ThemeProvider, __assign({ theme: themeDefault }, { children: _jsxs(Container, __assign({}, rest, { children: [_jsx(ScStub, {}, void 0), _jsx(Title, { children: "Add students to your class" }, void 0), _jsx(Text, { children: "After adding students to your class, this page will become available. Please go to the Roster to do so." }, void 0), _jsx(BlueButton, __assign({ onClick: handleOnClick, fit: true }, { children: "Go to Roster" }), void 0)] }), void 0) }), void 0));
};
export default EmptyClass;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
